
import { Checkbox, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import InputNumberCustom from './InputNumberCustom'
import Constant from 'utils/Constants';
// import moment from 'moment';
import InputLookup from './InputLookup';
import dayjs from 'dayjs'
import InputUploadFile from './InputUploadFile';
// import { UploadOutlined } from '@ant-design/icons';
import ButtonAction from './ButtonAction';
import { formatterAmount } from 'utils/Helper';
import { CloudUploadOutlined } from '@ant-design/icons';
import IconSearch from 'assets/icons/IconSearch';
import SwitchCustom from './SwitchCustom';
import CustomUploadImage from './CustomUploadImage';


const propsItem = {
    colon: false,
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
    labelAlign: 'left',
    validateTrigger: false
}


const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

export function CustomFormItem({
    withLabel = true,
    nameFormItem,
    label,
    style,
    className,
    wrapperCol = { span: 24 },
    rules = [],
    required,
    children
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
        >
            {children}
        </Form.Item>
    )
}

export function CustomFormItemText({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    labelCol = { span: 4 },
    rules = [],
    required,
    value = null,
    isView = false,
    styleInput = null,
    onChange = () => { },
    placeholder = "",
    maxLength = 8000,
    useInTable = false,
    disabled = false // ✅ tambahkan ini
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
        >
            {
                !isView ? <Input
                    allowClear
                    value={value}  
                    maxLength={maxLength}
                    placeholder={placeholder}
                    onChange={onChange}
                    style={styleInput}
                    title={value}
                    disabled={disabled} // ✅ tambahkan ini
                /> : <span className={`field-view ${!value ? 'field-empty' : ''}`}>{value}</span>
            }
        </Form.Item>
    )
}

export function CustomFormItemInteger({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    labelCol = { span: 4 },
    rules = [],
    required,
    value = null,
    isView = false,
    styleInput = null,
    onChange = () => { },
    onFocus = () => { },
    onBlur = () => { },
    min = 1,
    max = 10000,
    useInTable = false,
    alignView = "left",
    disabled = false
}) {
    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
            valuePropName="value"

        >
            {
                !isView ? (
                    <InputNumber
                        min={min}
                        max={max}
                        step={1}
                        precision={0}
                        value={value}
                        style={styleInput}
                        onChange={onChange}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        controls
                        disabled={disabled} // ✅ tambahkan ini
                    />
                ) : (
                    <span className={`field-view text-${alignView} ${useInTable ? 'field-view-table' : ''} ${!value ? 'field-empty' : ''}`}>
                        {value}
                    </span>
                )
            }
        </Form.Item>
    );
}

export function CustomFormItemIntegerLabelPercentage({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    labelCol = { span: 4 },
    rules = [],
    required,
    value = null,
    isView = false,
    styleInput = null,
    onChange = () => { },
    onFocus = () => { },
    onBlur = () => { },
    min = 1,
    max = 10000,
    useInTable = false,
    alignView = "left",
    disabled = false,
    suffix = "", // ✅ Tambahan: default kosong (tidak tampil)
}) {
    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
        >
            {
                !isView ? (
                    <InputNumber
                        min={min}
                        max={max}
                        step={1}
                        precision={0}
                        onChange={onChange}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        style={{ ...styleInput, width: '100%' }}
                        controls
                        disabled={disabled}
                        addonAfter={suffix || null} // ✅ % tampil di dalam input
                    />
                ) : (
                    <span className={`field-view text-${alignView} ${useInTable ? 'field-view-table' : ''} ${!value ? 'field-empty' : ''}`}>
                        {value}{suffix && ` ${suffix}`}
                    </span>
                )
            }
        </Form.Item>

    );
}

export function CustomFormItemTextArea({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    labelCol = { span: 4 },
    rules = [],
    required,
    value = null,
    isView = false,
    styleInput = null,
    onChange = () => { },
    placeholder = "",
    maxLength = 8000,
    rows = 2,
    useInTable = false,
    disabled = false
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
        >
            {
                !isView ? <Input.TextArea
                    placeholder={placeholder}
                    rows={rows}
                    maxLength={maxLength}
                    style={styleInput}
                    onChange={onChange}
                    value={value}
                    disabled={disabled}
                /> : <span className={`field-view ${useInTable ? 'field-view-table' : ''} ${!value ? 'field-empty' : ''}`}>{value}</span>
            }
        </Form.Item>
    )
}

export function CustomFormItemSelectDropdown({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    labelCol = { span: 4 },
    rules = [],
    required,
    value = null,
    isView,
    styleInput,
    onChange = () => { },
    placeholder,
    loading = false,
    showSearch = false,
    options = [],
    selectedLabel = null,
    useInTable = false,
    labelInValue = false, // ✅ tambahkan ini agar bisa dikontrol dari pemanggil
    disabled = false, // <=== Tambah disini
}) {
    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
        >
            {
                !isView ? <Select
                    allowClear
                    showSearch={showSearch}
                    optionFilterProp="children"
                    style={styleInput}
                    filterOption={filterOption}
                    placeholder={placeholder}
                    onChange={onChange}
                    options={options}
                    loading={loading}
                    value={value}
                    labelInValue={labelInValue} // ✅ WAJIB AGAR DAPAT { label, value }
                    disabled={disabled}
                /> : <span className={`field-view ${!selectedLabel && !options?.find(item => item.value === value)?.label ? 'field-empty' : ''}`}>{selectedLabel ? selectedLabel : options?.find(item => item.value === value)?.label}</span>
            }
        </Form.Item>
    )
}


export function CustomFormItemNumber({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    labelCol = { span: 4 },
    rules = [],
    required,
    isView = false,
    styleInput = null,
    onChange = () => { },
    onFocus = () => { },
    onBlur = () => { },
    initForm = null,
    nameInput = "",
    customvalue = null,
    precision = 2,
    min = 0,
    max = null,
    addonAfter = null,
    alignView = "left",
    useInTable = false,
    disabled = false, // <=== Tambah disini
}) {
    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
            valuePropName='value'
        >
            {
                !isView ? <InputNumberCustom
                    min={min}
                    max={max}
                    form={initForm}
                    name={nameInput}
                    customvalue={customvalue}
                    controls={true}
                    precision={precision}
                    style={styleInput}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    addonAfter={addonAfter}
                    disabled={disabled}
                     wrapperCol={wrapperCol}
            labelCol={labelCol}
                /> : (
                    <>
                        {addonAfter ? <div>
                            <span className={`field-view text-${alignView} ${useInTable ? 'field-view-table' : ''} ${!customvalue ? 'field-empty' : ''}`}>{customvalue} {addonAfter}</span>
                        </div>
                            :
                            <span className={`field-view text-${alignView} ${useInTable ? 'field-view-table' : ''} ${!customvalue ? 'field-empty' : ''}`}>{customvalue}</span>
                        }
                    </>
                )
            }

        </Form.Item>
    )
}



export function CustomFormItemMoney({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    // initialValue,
    rules = [],
    required,
    isView = false,
    styleInput,
    onChange = () => { },
    onFocus = () => { },
    onBlur = () => { },
    initForm,
    nameInput = "",
    customvalue = 0,
    precision = 2,
    min = 0,
    alignView = "left",
    useInTable = false
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
            valuePropName='value'
        >
            {
                !isView ? <InputNumberCustom
                    min={min}
                    form={initForm}
                    name={nameInput}
                    customvalue={customvalue}
                    value={customvalue}
                    withformat={true}
                    style={styleInput}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    precision={precision}
                /> : <span className={`field-view text-${alignView} ${useInTable ? 'field-view-table' : ''} ${!customvalue ? 'field-empty' : ''}`}>{formatterAmount(customvalue)}</span>
            }
        </Form.Item>
    )
}

export function CustomFormItemPhone({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    labelCol = { span: 24 },
    rules = [],
    required,

    isView = false,
    styleInput = null,
    onChange = () => { },
    placeholder = "",
    value = null,
    min = 0,
    max = null,
    useInTable = false
}) {
    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
        >
            {
                !isView ? <InputNumber
                    placeholder={placeholder}
                    min={min}
                    max={max}
                    value={value}
                    controls={false}
                    style={styleInput}
                    onChange={onChange}
                /> : (
                    <span className={`field-view ${useInTable ? 'field-view-table' : ''} ${!value ? 'field-empty' : ''}`}>{value}</span>
                )
            }

        </Form.Item>
    )
}

export function CustomFormItemEmail({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    rules = [],
    required,
    value = null,
    isView = false,
    styleInput = null,
    onChange = () => { },
    placeholder = "",
    maxLength = 8000,
    useInTable = false
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={[
                { type: 'email', message: 'Please enter a valid email' },
                ...rules
            ]}
            required={required}
        >
            {
                !isView ? <Input
                    allowClear
                    maxLength={maxLength}
                    placeholder={placeholder}
                    onChange={onChange}
                    style={styleInput}
                    title={value}
                /> : <span className={`field-view ${!value ? 'field-empty' : ''}`}>{value}</span>
            }
        </Form.Item>
    )
}



export function CustomFormItemDate({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    rules = [],
    required,
    initialValue = null, // ini dipakai JIKA ADA initial value pada field, harus diisi!!!, walaupun di ui tampil nilainya, tapi nilainya tidak terdetect kalau pakai validasi form.validate() (punya antd) sampai user ubah2 fieldnya
    //jadi misal field ini required rulesnya, initial datenya 17 Jan 2024 user tidak ubah2 field date ini dan langsung di submit, jika difungsi submit ada pakai validasi form.validate() maka dianggap seperti tidak ada nilainya padahal diui tampil tanggal 17 Jan 2024, nah props VALUE ini memang tidak terdetect oleh validasi form.validate() akan terdetect jika user mengubah nilai field ini.

    value,
    isView = false,
    styleInput,
    onChange = () => { },
    placeholder,
    disabledDate = () => { },
    onFocus = () => { },
    onBlur = () => { },
    useDatePickerView = false,
    useInTable = false
}) {
    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
            getValueProps={(i) => {
                let data = { value: i ? dayjs(i) : value ? dayjs(value) : null }
                return data
            }}
            initialValue={initialValue ? dayjs(initialValue) : null}
        >
            {(isView && useDatePickerView) && <DatePicker
                placeholder={placeholder}
                style={styleInput}
                format={Constant.datePickerFormat}
                onChange={onChange}
                disabledDate={disabledDate}
                onBlur={onBlur}
                onFocus={onFocus}
                disabled={true}
            />}

            {(isView && !useDatePickerView) &&
                <span className=
                    {`field-view ${useInTable ? ' field-view-table' : ''} ${!value ? 'field-empty' : ''}`}
                >
                    {value ? dayjs(value).format(Constant.datePickerFormat) : null}
                </span>
            }

            {(!isView && useDatePickerView) &&
                <DatePicker
                    placeholder={placeholder}
                    style={styleInput}
                    format={Constant.datePickerFormat}
                    onChange={onChange}
                    disabledDate={disabledDate}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
            }

            {(!isView && !useDatePickerView) &&
                <DatePicker
                    placeholder={placeholder}
                    style={styleInput}
                    format={Constant.datePickerFormat}
                    onChange={onChange}
                    disabledDate={disabledDate}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
            }


            {/* {
                !isView ? <DatePicker
                    placeholder={placeholder}
                    style={styleInput}
                    format={Constant.datePickerFormat}
                    onChange={onChange}
                    disabledDate={disabledDate}
                    onBlur={onBlur}
                    onFocus={onFocus}
                /> : useDatePickerView ? <DatePicker
                    placeholder={placeholder}
                    style={styleInput}
                    format={Constant.datePickerFormat}
                    onChange={onChange}
                    disabledDate={disabledDate}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    disabled={isView}
                /> : <span className='field-view'>{value ? dayjs(value).format(Constant.datePickerFormat) : null}</span>
            } */}
        </Form.Item>
    )
}

const displayDateRangeInView = (from, to) => {
    return (
        <div className="wrapper-date-range-in-view">
            <span className='field-view'>{from ? dayjs(from).format(Constant.datePickerFormat) : '-'}</span>
            {" - "}
            <span className='field-view'>{to ? dayjs(to).format(Constant.datePickerFormat) : '-'}</span>
        </div>
    )
}
export function CustomFormItemDateRange({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    rules = [],
    required,
    initialValue = null, // ini dipakai JIKA ADA initial value pada field, harus diisi!!!, walaupun di ui tampil nilainya, tapi nilainya tidak terdetect kalau pakai validasi form.validate() (punya antd) sampai user ubah2 fieldnya
    //jadi misal field ini required rulesnya, initial datenya 17 Jan 2024 user tidak ubah2 field date ini dan langsung di submit, jika difungsi submit ada pakai validasi form.validate() maka dianggap seperti tidak ada nilainya padahal diui tampil tanggal 17 Jan 2024, nah props VALUE ini memang tidak terdetect oleh validasi form.validate() akan terdetect jika user mengubah nilai field ini.

    value,
    isView = false,
    styleInput,
    onChange = () => { },
    placeholder,
    disabledDate = () => { },
    onFocus = () => { },
    onBlur = () => { },
    useDatePickerView = false,
    useInTable = false
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
        // getValueProps={(i) => {
        //     if (Array.isArray(i) && i.length === 2) {
        //         const [startDate, endDate] = i;
        //         let data = [
        //             startDate ? dayjs(startDate) : value ? dayjs(value) : null,
        //             endDate ? dayjs(endDate) : value ? dayjs(value) : null
        //         ]
        //         console.log("data1", data);
        //         return data
        //     } else {
        //         // Jika i bukan array, lakukan tindakan yang sesuai dengan kebutuhan aplikasi Anda
        //         // console.error("Invalid input for i:", i);
        //         let data = [null, null];
        //         console.log("data2", data);
        //         return data
        //     }
        // }}
        // initialValue={initialValue ? dayjs(initialValue) : null}
        >
            {
                !isView ? <DatePicker.RangePicker
                    placeholder={placeholder}
                    style={styleInput}
                    format={Constant.datePickerFormat}
                    onChange={onChange}
                    disabledDate={disabledDate}
                    onBlur={onBlur}
                    onFocus={onFocus}
                /> :
                    <>
                        {displayDateRangeInView(value[0], value[1])}
                    </>
            }
        </Form.Item>
    )
}

export function CustomFormItemLookup({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    initialValue,
    rules = [],
    required,

    isView = false,
    // styleInput,
    onSearch = () => { },
    placeholder = "",
    valueLookup = null,
    useInTable = false,
    useLookupView = false,
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
        // initialValue={initialValue}
        >
            {/* {
                !isView ? <InputLookup
                    onSearch={onSearch}
                    value={valueLookup}
                    placeholder={placeholder}
                // disableiconsearch={isView}
                /> : <span className=
                    {`field-view ${useInTable ? ' field-view-table' : ''} ${!valueLookup ? 'field-empty' : ''}`}
                >
                    {valueLookup}
                </span>
            } */}
            {(isView && useLookupView) && <InputLookup
                onSearch={onSearch}
                value={valueLookup}
                placeholder={placeholder}
                disableiconsearch={true}
            />}

            {(isView && !useLookupView) &&
                <span className=
                    {`field-view ${useInTable ? ' field-view-table' : ''} ${!valueLookup ? 'field-empty' : ''}`}
                >
                    {valueLookup}
                </span>
            }

            {(!isView && useLookupView) &&
                <InputLookup
                    onSearch={onSearch}
                    value={valueLookup}
                    placeholder={placeholder}
                // disableiconsearch={isView}
                />
            }

            {(!isView && !useLookupView) &&
                <InputLookup
                    onSearch={onSearch}
                    value={valueLookup}
                    placeholder={placeholder}
                // disableiconsearch={isView}
                />
            }
        </Form.Item>
    )
}

export function CustomFormItemUploadSingle({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    rules = [],
    required,

    isView = false,
    isHasFile = false,
    fileName = "",
    data = null,
    mediaType = "",
    maxSize = 0,
    onSelectedFile = () => { },
    onDownloadFile = () => { },
    onDeleteFile = () => { },
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} custom-form-item custom-form-item-upload`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
            valuePropName='data'
        >
            {
                <div className='wrapper-input-upload'>
                    <>
                        {(!isView && !isHasFile) && <InputUploadFile
                            mediaType={mediaType}
                            maxSize={maxSize}
                            onSelected={onSelectedFile}
                            labelClass="label"
                            icon={<CloudUploadOutlined />}
                        />}
                        <div className='wrap-filename'>
                            {isHasFile && (
                                <>
                                    <p className={`label-filename`} onClick={() => onDownloadFile(data)}>{fileName}</p>
                                    {
                                        (!isView && isHasFile) && <div className='wrap-button-delete'>
                                            <ButtonAction buttons={['delete']} onDelete={() => onDeleteFile(data)} />
                                        </div>
                                    }
                                </>

                            )
                                // : <span className=
                                //     {`field-view field-empty`}
                                // >No data</span>
                            }
                        </div>
                    </>
                </div>
            }
        </Form.Item>
    )
}

export function CustomFormItemCheckbox({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    rules = [],
    required,

    value = null,
    isView = false,
    // styleInput = null,
    onChange = () => { },
    title = "",
    useInTable = false
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
            valuePropName="checked"
        >
            {
                <Checkbox
                    disabled={isView}
                    onChange={onChange}
                    title={title}
                    checked={value}
                />
            }
        </Form.Item>
    )
}

export function CustomFormItemSwitch({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    labelCol = { span: 4 },
    rules = [],
    required,
    initialValue = false,
    value = false,
    isView = false,
    onChange = () => { },
    useInTable = false
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            labelCol={labelCol}
            rules={rules}
            required={required}
            valuePropName="checked"
            initialValue={initialValue}
        >
            {
                // <Checkbox
                //     disabled={isView}
                //     onChange={onChange}
                //     title={title}
                //     checked={value}
                // />
                !isView ? <SwitchCustom
                    checked={String(value).toLowerCase() === 'true'}
                    disabled={isView}
                    onChange={onChange}
                /> : <span className={`field-view ${!value ? 'field-empty' : ''}`}>{value ? "Yes" : "No"}</span>
            }
        </Form.Item>
    )
}

export function CustomFormItemPhoto({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 24 },
    rules = [],
    required,
    maxSize = 0,
    mediaType = "",
    widthImage = 300,
    heightImage = 300,
    imageSrc = "",

    value = null,
    isView = false,
    onChange = () => { },
    useInTable = false
}) {

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} ${useInTable ? 'custom-form-item-in-table' : ''} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={rules}
            required={required}
        >
            {
                !isView ? <CustomUploadImage
                    readOnly={isView}
                    maxSize={maxSize}
                    mediaType={mediaType}
                    widthImage={widthImage}
                    heightImage={heightImage}
                    imageSrc={imageSrc}
                    onChange={(imageSrc, file, fileName, size) => onChange(imageSrc, file, fileName, size)} /> : <span className={`field-view ${!value ? 'field-empty' : ''}`}>{value ? "Yes" : "No"}</span>
            }
        </Form.Item>
    )
}

export function CustomFormItemPassword({
    withLabel = true,
    nameFormItem = "",
    label = "",
    style = null,
    className = "",
    wrapperCol = { span: 8 },
    rules = [],
    required = false,
    value = null,
    isView = false,
    styleInput = null,
    onChange = () => { },
    placeholder = "",
    maxLength = 8000
}) {
    const finalRules = required
    ? [...rules, { required: true, message: `${label} is required.` }]
    : rules;

    return (
        <Form.Item
            {...propsItem}
            name={nameFormItem}
            label={withLabel ? label : null}
            style={style}
            className={`${className} custom-form-item`}
            wrapperCol={wrapperCol}
            rules={finalRules}
        >
            <Input.Password
                allowClear
                maxLength={maxLength}
                placeholder={placeholder}
                onChange={onChange}
                style={styleInput}
                title={value}
                disabled={isView}
            />
        </Form.Item>
    )
}

/**
 * FITER
 */

export function CustomFormItemFilterText({
    className = "",
    label = "",
    nameFormItem = "",
    value = null,
    disabled = false,
    styleInput = null,
    onChange = () => { },
    placeholder = "",
    maxLength = 8000,
    alignView = "left",
}) {
    // debugger
    return (
        <div className={`${className} custom-form-item-filter`}>
            {label && <label htmlFor={nameFormItem} className='label'>{label}</label>}
            <Input
                allowClear
                addonBefore={<IconSearch color="#d9d9d9" />}
                id={nameFormItem}
                name={nameFormItem}
                maxLength={maxLength}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                style={styleInput}
                title={value}
                disabled={disabled}
            />
        </div>
    )
}

export function CustomFormItemFilterSelectDropdown({
    nameFormItem = "",
    label = "",
    className = "",
    value = null,
    isView,
    styleInput,
    onChange = () => { },
    placeholder,
    loading = false,
    showSearch = false,
    options = [],
}) {

    return (
        <div className={`${className} custom-form-item-filter`}>
            {label && <label htmlFor={nameFormItem} className='label'>{label}</label>}
            <div className="wrapper-select">
                <span className='icon'>{<IconSearch color="#d9d9d9" />}</span>
                <Select
                    allowClear
                    id={nameFormItem}
                    name={nameFormItem}
                    showSearch={showSearch}
                    optionFilterProp="children"
                    style={{ ...styleInput, width: "100%" }}
                    filterOption={filterOption}
                    placeholder={placeholder}
                    onChange={onChange}
                    options={options}
                    loading={loading}
                    value={value}
                    disabled={isView}
                />
            </div>
        </div>
    )
}

export function CustomFormItemFilterDate({
    nameFormItem = "",
    label = "",
    className = "",
    value,
    isView = false,
    styleInput,
    onChange = () => { },
    placeholder,
    disabledDate = () => { },
    onFocus = () => { },
    onBlur = () => { },
}) {
    // debugger
    return (
        <div className={`${className} custom-form-item-filter`}>
            {label && <label htmlFor={nameFormItem} className='label'>{label}</label>}
            <div className="wrapper-datepicker">
                <span className='icon'>{<IconSearch color="#d9d9d9" />}</span>
                <DatePicker
                    placeholder={placeholder}
                    style={styleInput}
                    format={Constant.datePickerFormat}
                    value={value ? dayjs(value) : null}
                    onChange={onChange}
                    disabledDate={disabledDate}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    disabled={isView}
                />
            </div>
        </div>
    )
}



